import React from 'react'
import Select from 'react-select'

import 'react-select/dist/react-select.css'

const SELECTS = require('../Datas/Selects')

const BonsPLansJeunesFormFilterThemes = ({ 
	bonsPLansJeunesFilterFilterActiveThemes, 
	OnChangeFilterThemes, 
	AgendaFilterActiveOther 
}) => {
	// Validation des props
	if (!OnChangeFilterThemes || typeof OnChangeFilterThemes !== 'function') {
		return null;
	}

	if (!SELECTS || !SELECTS['themes'] || !Array.isArray(SELECTS['themes'])) {
		return null;
	}

	return (
		<div 
			className="bons-plans-jeunes-filter-themes-container generic-filters-select generic-filters-select-category"
			role="group"
			aria-label="Filtre par thème pour les bons plans jeunes"
			aria-describedby="filter-themes-description"
		>
			<div id="filter-themes-description" className="visually-hidden">
				Sélectionnez le thème pour filtrer les bons plans jeunes
			</div>
			<Select 
				className="agenda-filters-select agenda-filters-select-category" 
				name="agenda-filters-category" 
				placeholder="Thématiques" 
				options={SELECTS['themes']} 
				onChange={OnChangeFilterThemes}
				value={bonsPLansJeunesFilterFilterActiveThemes}
				simpleValue
				clearable={false}
				searchable={false}
				aria-label="Sélection du thème"
				aria-describedby="filter-themes-description"
			/>
		</div>
	);
};

export default BonsPLansJeunesFormFilterThemes
